export const getValueFromStorage = (key) => {
    var valueStored = sessionStorage.getItem(key)
    if (!valueStored) {
        valueStored = localStorage.getItem(key)
    }

    return valueStored
}
